(function InitLogoBehavior() {
	const body = document.querySelector('body');
	const headerLogo = document.querySelector('.header__logo');
	const headerWrap = headerLogo?.closest('.shopify-section');

	// The header slides back in on scroll-up (class "header--scrolled-down"
	// removed) - its logo has to show again then, instead of the floating logo-8.
	const update = () => {
	  const scrolled = window.scrollY;
	  const halfway = window.innerHeight * 0.5;
	  const pastHalfway = scrolled > halfway;
	  const headerShown =
	    !!headerWrap &&
	    !headerWrap.classList.contains('header--scrolled-down');

	  body.classList.toggle("home-scroll-50", pastHalfway);
	  body.classList.toggle("header-shown", headerShown);
	  headerLogo?.classList.toggle("is-hidden", pastHalfway && !headerShown);
	};

	window.addEventListener("scroll", update);
	window.addEventListener("resize", update);
	if (headerWrap) {
	  new MutationObserver(update).observe(headerWrap, { attributes: true, attributeFilter: ['class'] });
	}
	update();
})();


(function InitMenuGender() {
	// The visitor's current section (men / women) is remembered in the fd_gender
	// cookie (see layout/theme.liquid). The menu defaults to the first entry
	// ("Man"), so when the visitor is shopping the other section, switch to it:
	// - desktop: the Shop dropdown pre-selects it
	// - mobile drawer: it opens straight into that panel
	const match = document.cookie.match(/(?:^|; )fd_gender=([^;]*)/);
	const pref = match && decodeURIComponent(match[1]);
	if (pref !== 'men' && pref !== 'women') return;

	const startsWith = pref === 'women' ? 'wom' : 'man';
	const matches = el => el.textContent.trim().toLowerCase().startsWith(startsWith);

	document.addEventListener('DOMContentLoaded', () => {
		// Desktop dropdown: a click is what the header script listens to to swap
		// the active group (and its card images), so reuse it.
		const desktopLink = [...document.querySelectorAll('.header__nav--custom > .header__nav-links-item > .header__nav-dropdown-link')]
			.find(matches);
		if (desktopLink && !desktopLink.classList.contains('is-active')) desktopLink.click();

		// Mobile drawer: when it opens with no panel showing, go to the matching one.
		const drawer = document.getElementById('Navigation-drawer-header');
		if (!drawer) return;

		const openPanel = () => {
			if (!drawer.classList.contains('menu-opening')) return;
			if (document.querySelector('.menu-panel.is-active')) return;
			const button = [...document.querySelectorAll('.primary-menu-panel button.menu-link')].find(matches);
			button?.click();
		};

		new MutationObserver(openPanel).observe(drawer, { attributes: true, attributeFilter: ['class'] });
	});
})();
